import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@wfp-root-app/store/store';
import { useParams } from 'react-router-dom';

import PermissionsFiles from '../permissions-files/PermissionsFiles';
import { ActionCreators, defaultVendorSortingOrder, Vendor, VendorGeneralInfo } from './vendors';
import { ManagerPermission } from '../permission-profiles/permission';
import State from '../app/store/state';

function VendorPermissionsFiles() {
    const params = useParams();
    const dispatch = useAppDispatch();
    const { vendors } = useSelector((state: State) => state);
    const vendorData = vendors.list.find((v) => v.id.toString() === params.vendorId) || new Vendor();
    const vendor = new VendorGeneralInfo(vendorData);

    const uploadPermissionsFile = (userId: string, file: File) => {
        return dispatch(ActionCreators.uploadPermissionsFile(userId, file));
    };

    const loadVendors = () => {
        dispatch(ActionCreators.loadVendors(defaultVendorSortingOrder));
    };

    return (
        <PermissionsFiles
            loadUsers={loadVendors}
            permissionsFiles={vendor.permissionsFiles}
            requiredPermission={[ManagerPermission.vendorsPark, ManagerPermission.vendorsPost]}
            uploadPermissionsFile={uploadPermissionsFile}
            userId={vendor.id}
        />
    );
}

export { VendorPermissionsFiles };
